import {useDispatch, useSelector} from "react-redux";
import {
    closeLobbyModal,
    lobbyOpenModal,
    selectActiveRoomTab,
    toggleAudio
} from "../../../../../redux/actions/lobby/actions";
import {setActivePage} from "../../../../../redux/actions/lobby/actions";
import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {
    cleanUpHistoryRooms,
    closeRoom,
    openRoomCloseModal,
    roomViewExit
} from "../../../../../redux/actions/rooms/actions";
import {setHistorySelectedRoomId} from "../../../../../redux/actions/history/actions.js";

function SideMenuMobile() {
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const {activeRoomId, rakeRace, audioEnabled} = useSelector(state => state.lobby);
    const enteredRooms = useSelector(state => state.rooms);
    const [isMenuOpen, setMenuOpen] = useState(false);
    const handleOpenMenu = () => {
        setMenuOpen(true);
    }
    const handleCloseMenu = () => {
        dispatch(closeLobbyModal());
        setMenuOpen(false);
    }

    const handleClick = (name) => {
        setMenuOpen(false);
        dispatch(setActivePage({activePage: name}));
    }
    const toggleMuted = () => {
        dispatch(toggleAudio());
    }

    const logoutRoom = () => {
        const room = enteredRooms[activeRoomId];
        if (!room) return;
        if (room?.state === 'FINISHED') return;
        setMenuOpen(false);
        if (!room?.isViewRoom) {
            if (room?.status === 'PROGRESS') {
                dispatch(openRoomCloseModal({roomId: activeRoomId}));
                dispatch(selectActiveRoomTab({roomId: activeRoomId}));
            } else {
                dispatch(closeRoom({roomId: activeRoomId}));
            }
            return
        }
        if (room?.historyRoomPlayer) {
            dispatch(cleanUpHistoryRooms());
            dispatch(selectActiveRoomTab({roomId: null}));
            dispatch(setHistorySelectedRoomId({roomId: null}));
            return
        }
        return dispatch(roomViewExit({roomId: activeRoomId}));
    }
    const exitFromGame = () => {
        window.parent.postMessage({action: 'goHome'}, '*');
    }

    return (
        <div className="mobile-header-menu">
            {rakeRace?.isActive &&
                <i className="icon-rake-race"
                   onClick={() => dispatch(lobbyOpenModal({name: 'RakeRace'}))}
                />
            }
            <i className="icon-burger" onClick={handleOpenMenu}/>
            <div className={`mobile-header-menu-content ${isMenuOpen ? "open" : ""}`}>
                <div className="mobile-header-menu--close" onClick={handleCloseMenu}>
                    <i className="icon-close"/>
                </div>
                <ul className="mobile-header-menu__options">
                    <li className="mobile-header-menu__options--item"
                        onClick={() => handleClick("Cash")}>
                        <span className="title">{t('mobile_side_menu.home')}</span>
                        <i className="icon-burger"/>
                    </li>
                    <li className="mobile-header-menu__options--item"
                        onClick={() => {
                            setMenuOpen(false)
                            dispatch(lobbyOpenModal({name: 'HowToPlay'}))
                        }}>
                        <span className="title">{t('mobile_side_menu.how_to_play')}</span>
                        <i className="icon-0"/>
                    </li>
                    <li className="mobile-header-menu__options--item"
                        onClick={() => handleClick("History")}>
                        <span className="title">{t('mobile_side_menu.history')}</span>
                        <i className="icon-history"/>
                    </li>
                    <li className="mobile-header-menu__options--item"
                        onClick={() => {
                            setMenuOpen(false)
                            dispatch(lobbyOpenModal({name: 'Settings'}))
                        }}>
                        <span className="title">{t('mobile_side_menu.settings')}</span>
                        <i className="icon-settings"/>
                    </li>
                    <li className="mobile-header-menu__options--item" onClick={toggleMuted}>
                        <span className="title">{t('mobile_side_menu.volume')}</span>
                        <i className={audioEnabled ? 'icon-vol' : 'icon-volOff'}/>
                    </li>
                    {
                        activeRoomId && <li className="mobile-header-menu__options--item" onClick={logoutRoom}>
                            <span className="title">{t('mobile_side_menu.logout')}</span>
                            <i className='icon-Logout'/>
                        </li>
                    }
                    <li className="mobile-header-menu__options--item" onClick={exitFromGame}>
                        <span className="title">{t('mobile_side_menu.exit')}</span>
                        <i className="icon-home"/>
                    </li>
                </ul>
            </div>
        </div>
    )
}

export default SideMenuMobile